import { SVGProps } from "react";

const TrendUpIcon = ({
  width = 16,
  height = 16,
  color = "#00852D",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="8" cy="8" r="8" fill={color} />
    <path
      d="M5.33 9.33L8 6.67L10.67 9.33"
      stroke="#FFFFFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrendUpIcon;
